import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth74: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.5,125.1l-5.5-14.5.2-16,2.2-9,4.2-9.9s13.7,13.7,28.6,13.9l.3,12.9s-22.4,8.8-29.9,22.7h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M150.8,88.6l-.5,12.7s20.9-2.5,30.1,13.7l2-8.2,1-8.5v-5.3l.7-7-1.3-9.7s-14.9,11-31.9,12.4h-.1Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M57.4,102.4s9.9,0,20.3,4.4,18.6,7.8,28.2,7.8,20.5-5.4,25.1-8.5c6.6-4.5,19.3-4.6,19.3-4.6l.5-12.7s-14.2-.8-22.1-4.8-14.7-9.1-25.8-9.1-19.2,6.4-26.4,10.2-19.6,4.4-19.6,4.4l.3,12.9h.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.5,125.1s5.3-12.3,29.9-22.7c0,0,9.6-.3,20.3,4.4,20.4,9,28.2,7.8,28.2,7.8,0,0,7.7,18.9.5,44.7l-3.1-1-6.9-1.3-6.7-.9h-8.2c0-.1-9.3-1.2-9.3-1.2l-10-3-9.5-4.8-8.8-5.9-8.8-6.7-5.1-5.4-2.5-4.2v.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.9,114.6s10.8.2,25.1-8.5c14.3-8.7,44.4-6.3,49.3,9.1l-1.2,6.6-2.3,7.6-3,5.5-3.9,4.4-8.1,6.6-3.6,2.8-6.1,4.8-5,2.5-9.3,2.8-11.6,3.1h-13l-7-2.6s7.3-21.3-.5-44.7h.2Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.5,75.7l3.6-8.1,2.4-5,5.3-6.9,6.2-5.8,7.5-6,7.1-4.5,9.5-4.3,8.3-2.7,6.8-1.8,9.7-1.9,5.6-.5s11.4,11.6,3.2,46.8c0,0-9.2-.3-27,10.2-8,3.3-13.7,4.4-19.6,4.4-15.3,0-28.6-13.9-28.6-13.9Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.5,28.2l23.4-.3,9,1.4,5.9,1.7,5.3,2.4,4.8,2.4,5.2,3.2,6,4.2,5.6,5.1,4,4.5,3.6,3.9,3.1,4.2,2.8,4.5,1.6,3.4,1.4,3.6.6,4.1s-14.6,10.8-31.9,12.4-17.6-3-22.1-4.8-14.3-9.3-25.1-9.1c0,0,8.3-29.4-3.2-46.8h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.6,160.9c-14.8,3.8-25.7-5.5-41.5-5.7-11.1-.2-22.5-2.4-32.3-8.2-8.3-5-16.7-10.3-23.2-17.8s-9.4-19.4-8.5-29.1c1.4-15.6,9.7-38,21.1-47.6s12.2-10.9,19.8-14.2c10.3-4.4,20.5-8.2,31.8-9,13.2-.9,26.6-2.3,39.5,1.3,22.6,6.3,46.4,27.5,49.1,52.3l-1.1,21.1c-.4,7.4-2.9,14.5-5.1,21.5s-6.4,13-12.8,17.2-8.5,7.8-13.4,10.5c-7.1,3.9-15.5,5.6-23.7,7.7Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M108.5,437.2A12.6,12.6 0 1 0 83.3,437.2A12.6,12.6 0 1 0 108.5,437.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M56.7,474.3v-40.9s-.3-9.8-10.8-9.8h-28.7v19.1c0,0,1.3,3.1,1.3,3.1l7,5.9,9.7,6.6,9.3,6.5,7.7,6.8,4.4,2.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.1,423.8l1.7,9.6v5.8l-2.2,6.9-3.7,6.4-2.9,6.7-3.8,6.2-7.4,7.2-7.8,5-10.2.2v-43.6c0,0-1-10.7,10.1-10.7s26.3.4,26.3.4Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.4,374.6s42.8,29.4,69.4,29.4,66-15.8,66-15.8l-.4-9.1s-40.4,17-66.9,15.2c-28.9-2-66.8-27.8-66.8-27.8l-1.4,8.1Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96,465.2l-10.2,3.5-2.3,2.8-5.8,3-4.4,1.2-4,.9h-7.9l-4.6-2.3-13.8-10.8-11.9-8.1-7.9-5.6-4.5-3.6-1.4-3.4v-19.1c0,0,.7-11.6.7-11.6l2-13.3,3.1-13,1.4-11s41.4,28.2,69.4,29.4c0,0,6.5,18.5,2.2,61.2Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M159.8,388.2l2.3,7.7,4.6,13.4,1.4,8.8,1,5.7,1.7,9.1v6.2s-2.2,6.9-2.2,6.9l-3.9,7.1-2.7,6-3.8,6.2-7.4,7.2-7.8,5-10.2.2-7.1-2.8-6.6-1.9-4.8-2.2-5.3-5.8-3.3-2.8-3.3,1.1-3.8,1.2-2.5.8s4.4-36-2.2-61.2c0,0,20.2,1.2,66-15.8Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107,462c-2.3-.7-5.8,1.4-7.7,2.2-4.2,1.8-9.1,1.6-12.7,4.4-12,9.4-26.1,10.6-37.1-.1s-12.2-10.6-19.5-14.6-9.1-6.1-12.5-10.8c-1.7-18.5.5-36.7,4.9-54.9l2.9-18.1c17.2,25.3,46.4,37.9,76.8,35.4,20.3-1.6,38.6-8.3,57.2-17.9l6.2,19.6,4.6,24.4c1.4,7.6-1.6,13.2-4.7,19.5s-9.4,16.8-17.4,22.5-13.9,4-21.7,1c-7.4-2.9-14.6-4.6-19.2-12.8Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.6,79.8A11.4,11.4 0 1 0 87.8,79.8A11.4,11.4 0 1 0 110.6,79.8Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.6,120.8s22.1,30.1,72.4,13.6c65.7-21.5,68.2-18.8,68.2-18.8l-.8,7.2s-35.4,8.8-66.3,19.7c-43.1,15.2-71.8-11-71.8-11l-1.8-10.7Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.1,76.6l.5-22,3.4-10.3,5.8-9.9,5.3-4.7,6-1.4,6.7-.4,9.9-2.5,6.1-1.4v36.6s.9,15.5-13.5,15.5-30.2.4-30.2.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148,38.3l9.7-2.1,6.2.4,3.6,1.7,4.1,5.3,1.7,4.2,1.5,5.7,1.7,10.1,1.6,8.7v3.7h-21.4s-8.7-.2-8.7-8.2-.1-29.6-.1-29.6Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.4,29.9s10.3,69.7,0,104.6c0,0-45,17.9-71.9-13.7l-.9-5.2-1.5-8.2-1.2-5.5-.7-7-1-5.1v-13.3c-.1,0,.4-22,.4-22l3.4-10.2,5.8-9.9,5.3-4.7,6-1.4,6.7-.4,16-3.8,5.2-1.8,7.8-.2,20.6,7.9Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.4,29.9l11.8,2.3,14.9,2.8,9.5,2,4.1,2.2,7.3-.9,9.7-2.1,6.3.4,3.7,1.9,3.9,5.1,1.7,4.2,1.5,5.9,1.9,10.6,1.2,7.4v18.2c0,0-2.3,10.5-2.3,10.5l-2.9,8.6-3.6,6.5s-4.6-1.7-68.8,18.9c0,0,10.2-28.6,0-104.6Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M170,114.5c-21.5-7.1-49.7,3.6-69.7,14.5-15.6,13.1-32.2,22.9-50.9,12.6s-13.8-9-20-15.1c-1.9-13.6-5-26.6-5.8-40.5l.2-24.3c0-8.4,2.5-15.5,6.4-22.5s9.7-10.4,18-11.1l24.5-5.3c4.5-1,8.9.1,13.2,1.7l18.3,6.6c11,2.3,21.8,3.3,32.6,6.2,3.3,3.7,12.4.4,23-.5s11.5,4.1,12.9,9.5c6.4,25.4,8,44.4-2.5,68.2Z',
			},
		},
	},
};
